export default "__VITE_ASSET__B8f4j5PG__"